import React, { cloneElement, Fragment } from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { Redirect } from 'react-router-dom';
import { activeEditIdSelector } from '@store/comparison/selectors';
import { isAppModule } from '@utils/constants';

const { baseUrl } = window.conviva;

const WithModifyComparison = ({ children, activeCompareEditId, ...props }) => {
  if (activeCompareEditId === null) {
    if (isAppModule) {
      return <Redirect to={`${baseUrl}/dashboard/app-experience`} />;
    }
    return <Redirect to={`${baseUrl}/dashboard/trends`} />;
  }

  const childElement = cloneElement(children, {
    ...props,
  });
  return <Fragment>{childElement}</Fragment>;
};

const selector = createSelector(activeEditIdSelector, (activeCompareEditId) => ({
  activeCompareEditId,
}));

export default connect(selector, null)(WithModifyComparison);

WithModifyComparison.defaultProps = {
  activeCompareEditId: null,
};
